const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  const year = date.getUTCFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return {year, month, day, hours, minutes}
}

export default formatDate
